import moment from 'moment'

export default class Member {
    constructor (json) {
        this.properties = []
        // eslint-disable-next-line no-unused-vars
        for (const key in json) {
            this.properties[key] = json[key]
        }

        if (json.token !== undefined) {
            const ttl = json.token.ttl
            this._expiresDT = moment().add(ttl, 'seconds')
        }
    }

    getProperty (name) {
        return this.properties[name]
    }

    setProperty (name, value) {
        this.properties[name] = value
    }

    static fromStore (json) {
        return new Member({
            accountNumber: json.accountNumber,
            firstName: json.firstName,
            lastName: json.lastName,
            memberId: json.memberId,
            memberAccessToken: json.memberAccessToken,
            memberRefreshToken: json.memberRefreshToken,
            expiresIn: moment(json.expiresIn)
        })
    }

    toStore () {
        const accessToken = this.getProperty('memberAccessToken') || this.properties.token.memberAccessToken
        const memberRefreshToken = this.getProperty('memberRefreshToken') || this.properties.token.memberRefreshToken

        return {
            accountNumber: this.properties.accountNumber,
            firstName: this.properties.firstName,
            lastName: this.properties.lastName,
            memberId: this.properties.memberId,
            memberAccessToken: accessToken,
            memberRefreshToken: memberRefreshToken,
            expiresIn: this._expiresDT || this.properties.expiresIn
        }
    }

    isExpired () {
        return this.getProperty('expiresIn') <= moment()
    }
}

// success
// {
//     "responseCode": "SUCCESS",
//     "accountNumber": "3026436",
//     "firstName": "Dave",
//     "lastName": "Collins",
//     "rewardBalance": 0,
//     "expiringRewardAmount": 0,
//     "expiringRewardDate": " ",
//     "redemptionCard": false,
//     "memberId": "3304925500",
//     "memberIdStatus": "ACT",
//     "memberAttributes": [],
//     "token": {
//         "memberAccessToken": "f4a8f6f5-3a98-4dfe-afd5-6e53d1c4e803",
//         "ttl": 900,
//         "memberRefreshToken": "vOB64Jr9ouFkI/1jzdL5iMlFTqfWgnZFwWOf/Cr1w35mmHKBxF51Puy6OtLYyFxjlxztBeUXOtQDH1F4RIkbLkWibil7SCHKk+WjxQWml5Uu5nrDovYpFWLbJHL3O0ybFNqGowgO8ZCEmzXf4kwn3/ckmHssPLMkjvDsQMq3G2s="
//     }
// }

// error
// {
//     "errors": [
//         {
//             "errorCode": 704,
//             "errorMessage": "Email Already used for another account"
//         }
//     ],
//     "responseCode": "FAILURE",
//     "displayErrorMessage": "The email entered is already in use"
// }



// WEBPACK FOOTER //
// ./src/models/entities/Member.js